module.exports = __webpack_public_path__ + "static/html_5-4d80b8552ea6ebc06957b62f38d32299.jpg";